<template>
    <layout-with-sidebar>
        <HeaderComponent/>
        <div class=" ed-bg text-color" style="min-height:100vh">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="navbar navbar-expand-lg navbar-light bg-light  row">
                            <div class="col-2 text-left">
                                <button class="btn btn-default "> <
                                </button>
                            </div>
                            <div class="col-6 text-center">
                                <button class="btn btn-default ">-</button>
                                <button class="btn btn-default " style="margin-left:20px;">+</button>
                            </div>
                            <div class="col-4 text-right">
                                <button @click="resizeCanvasTemplateCambiale" class="btn btn-success my-2 my-sm-0"
                                        type="submit">
                                    Template C
                                </button>
                                <button @click="save" class="btn btn-success my-2 my-sm-0" type="submit">Salva
                                </button>
                                <button @click="uploadImage" class="btn btn-success my-2 my-sm-0" type="submit">Carica
                                    immagine
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-9">

                        <canvas id="editor">

                        </canvas>

                    </div>

                    <div class="col-3">
                        <div style="width:500px;height: 400px">
                            <vue-cropper
                                    ref="cropper"
                                    :src="image"
                                    alt="Source Image"

                            >
                            </vue-cropper>
                            <img id="croppedImg" style="display: none">
                        </div>

                        <a
                                class="btn btn-primary"
                                href="#"
                                role="button"
                                @click.prevent="showFileChooser"
                        >
                            Carica img
                        </a>

                        <input
                                ref="input"
                                type="file"
                                name="image"
                                accept="image/*"
                                @change="setImage"
                                style="display: none"
                        />


                        <button class="btn btn-primary" @click="setBackground">BG</button>
                        <button class="btn btn-primary" @click="setBackgroundC">BG-C</button>

                        <button class="btn btn-primary" @click="deleteBackground">Elimina BG</button>
                        <br>
                        <button class="btn btn-primary" @click="deleteFabricObject()">Elimina</button>
                        <button class="btn btn-primary" @click="addTextObject">Aggiungi Testo</button>


                        <div v-if="currentObject">
                            Left: <input type="number" v-model="currentObjectLeft"
                                         width="20">mm
                            Top: <input type="number" v-model="currentObjectTop"
                                        width="20">mm<br>
                            Width: {{pxToMm(currentObject.width*currentObject.scaleX)}}mm
                            Height: {{pxToMm(currentObject.height*currentObject.scaleY)}}mm<br>
                        </div>


                        <br>
                        <label for="font-family" style="display:inline-block">Font family:</label>
                        <select id="font-family" v-model="fontFamily" @change="setFontFamily">
                            <option value="times new roman">Times New Roman</option>
                            <option value="arial">Arial</option>
                            <option value="helvetica" selected>Helvetica</option>
                            <option value="myriad pro">Myriad Pro</option>
                            <option value="delicious">Delicious</option>
                            <option value="verdana">Verdana</option>
                            <option value="georgia">Georgia</option>
                            <option value="courier">Courier</option>
                            <option value="comic sans ms">Comic Sans MS</option>
                            <option value="impact">Impact</option>
                            <option value="monaco">Monaco</option>
                            <option value="optima">Optima</option>
                            <option value="hoefler text">Hoefler Text</option>
                            <option value="plaster">Plaster</option>
                            <option value="engagement">Engagement</option>
                        </select>
                        <br>

                        <div>
                            <label>Colore:</label>
                            <input type="color" v-model="textColor" @change="setTextColor">
                        </div>
                        <br>

                        <div>
                            <label>Sfondo:</label>
                            <input type="color" v-model="backgroundColor" @change="setBackgroundColor">
                        </div>


                        <div>
                            <label>Font size: {{fontSize}}px</label>
                            <input type="range" v-model="fontSize" value="" min="1" max="120" step="1"
                                   @change="setFontSize">
                        </div>

                    </div>


                </div>


            </div>
        </div>
    </layout-with-sidebar>
</template>


<script>
    // @ is an alias to /src

    // import LayoutWithSidebar from "./layouts/LayoutWithSidebar";
    import HeaderComponent from "../../components/HeaderComponent";
    import {fabric} from 'fabric'

    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';
    import axios from "axios";
    import download from "downloadjs";

    fabric.Object.prototype.toObject = (function (toObject) {
        return function () {
            return fabric.util.object.extend(toObject.call(this), {
                id: this.id,
                text: this.text,
                fontSize: this.fontSize
            });
        };
    })(fabric.Object.prototype.toObject);

    export default {
        name: 'HtmlEditorFabric',
        components: {
            //     LayoutWithSidebar,
            HeaderComponent,
            VueCropper

        },
        data: function () {
            return {
                canvas: null,
                image: null,
                fontSize: 16,
                textColor: 'black',
                fontFamily: 'times new roman',
                currentObject: null,
                backgroundColor: '',
                background_width: 0,
                background_height: 0,
                currentObjectLeft: 0,
                currentObjectTop: 0,
                fields: [
                    {
                        id: 'amortization_rate.amount',
                        placeholder: 'Totale',
                        position: {
                            left: 876,
                            top: 43
                        }
                    },
                    {
                        id: 'amortization.abl',
                        placeholder: 'A B L',
                        position: {
                            left: 47,
                            top: 370
                        }
                    },
                    {
                        id: 'amortization.cab',
                        placeholder: 'C A B',
                        position: {
                            left: 220,
                            top: 369
                        }
                    },
                    {
                        id: 'amortization.debtor_first_name',
                        placeholder: 'Nome Deb',
                        position: {
                            left: 412,
                            top: 271
                        }
                    },
                    {
                        id: 'amortization.debtor_last_name',
                        placeholder: 'cognome Deb',
                        position: {
                            left: 589,
                            top: 271
                        }
                    },
                    {
                        id: 'amortization.debtor_fiscal_code',
                        placeholder: 'codice fiscale Deb',
                        position: {
                            left: 549,
                            top: 314
                        }
                    },
                    {
                        id: 'amortization.debtor_address',
                        placeholder: 'Indirizzo Deb',
                        position: {
                            left: 407,
                            top: 338
                        }
                    },
                    {
                        id: 'amortization.debtor_city',
                        placeholder: 'Prov. Deb',
                        position: {
                            left: 617,
                            top: 373
                        }
                    },
                    {
                        id: 'amortization.debtor_city',
                        placeholder: 'Città Deb',
                        position: {
                            left: 407,
                            top: 309
                        }
                    },
                    {
                        id: 'amortization.debtor_zip_code',
                        placeholder: 'CAP Deb',
                        position: {
                            left: 407,
                            top: 373
                        }
                    },
                    {
                        id: 'amortization.debtor_town',
                        placeholder: 'Comune Deb',
                        position: {
                            left: 500,
                            top: 373
                        }
                    },
                    {
                        id: 'amortization.signature_first_name',
                        placeholder: 'Nome Firma',
                        position: {
                            left: 781,
                            top: 269
                        }
                    },
                    {
                        id: 'amortization.signature_last_name',
                        placeholder: 'Cognome Firma',
                        position: {
                            left: 784,
                            top: 294
                        }
                    },
                    {
                        id: 'amortization.signature_fiscal_code',
                        placeholder: 'Cod. Fiscale Firma',
                        position: {
                            left: 780,
                            top: 316
                        }
                    },
                    {
                        id: 'amortization.pay_address',
                        placeholder: 'Indirizzo Dom.',
                        position: {
                            left: 30,
                            top: 302
                        }
                    },
                    {
                        id: 'amortization.pay_zip_code',
                        placeholder: 'Cod. Fiscale Dom.',
                        position: {
                            left: 34,
                            top: 334
                        }
                    },
                    {
                        id: 'amortization.pay_city',
                        placeholder: 'Città Dom.',
                        position: {
                            left: 252,
                            top: 302
                        }
                    },
                    {
                        id: 'amortization.pay_town',
                        placeholder: 'Comune Dom.',
                        position: {
                            left: 118,
                            top: 302
                        }
                    },
                    {
                        id: 'amortization.pay_name',
                        placeholder: 'Nome Dom.',
                        position: {
                            left: 34,
                            top: 272
                        }
                    },
                    {
                        id: 'amortization.type_promissory_note',
                        placeholder: 'Tipo Cambiale',
                        position: {
                            left: 748,
                            top: 86
                        }
                    },
                    {
                        id: 'amortization.avallante1',
                        placeholder: 'Avallante 1',
                        position: {
                            left: 24,
                            top: 409
                        }
                    },
                    {
                        id: 'amortization.avallante2',
                        placeholder: 'Avallante 2',
                        position: {
                            left: 189,
                            top: 408
                        }
                    },
                    {
                        id: 'amortization.code',
                        placeholder: 'Codice',
                        position: {
                            left: 16,
                            top: 44
                        }
                    }
                    ,
                    {
                        id: 'amortization.date_issue',
                        placeholder: 'Data Scadenza',
                        position: {
                            left: 430,
                            top: 25
                        }
                    },
                    {
                        id: 'amortization.place_issue',
                        placeholder: 'Luogo',
                        position: {
                            left: 353,
                            top: 24
                        }
                    },
                    {
                        id: 'amortization.total_in_letters',
                        placeholder: 'Totale in lettere',
                        position: {
                            left: 352,
                            top: 175
                        }
                    }
                ]
            }
        },
        mounted: function () {
            var vm = this


            vm.canvas = new fabric.Canvas('editor');
            vm.canvas.setHeight(fabric.util.parseUnit('210mm'));
            vm.canvas.setWidth(fabric.util.parseUnit('297mm'));
            vm.canvas.setBackgroundColor('white')
            vm.canvas.on('mouse:down', function (options) {
                if (options.target) {
                    vm.currentObject = options.target
                    vm.currentObjectLeft = vm.pxToMm(vm.currentObject.left)
                    vm.currentObjectTop = vm.pxToMm(vm.currentObject.top)

                    console.log(vm.currentObject)
                }
            });
            this.getUserTemplate()


            /*
              var alltogetherObj = new fabric.Group(objs,{
                            top:200,left:250,
                            originX:'center',
                            originY:'center'});
             */


        },
        watch: {
            currentObjectTop: function (value, oldVal) {
                if (this.canvas.getActiveObject()) {
                    this.canvas.getActiveObject().set({top: fabric.util.parseUnit(value + 'mm')});
                    this.canvas.renderAll()
                }
            },
            currentObjectLeft: function (value, oldVal) {
                if (this.canvas.getActiveObject()) {
                    this.canvas.getActiveObject().set({left: fabric.util.parseUnit(value + 'mm')});
                    this.canvas.renderAll()
                }
            }
        },
        computed: {},
        methods: {
            resizeCanvasTemplateCambiale: function () {
                var vm = this
                var currentBackgroundImage = this.canvas.getObjects().filter(function (o) {
                    return o.get('id') === 'background';
                });

                currentBackgroundImage = currentBackgroundImage[0]
                vm.canvas.setWidth(currentBackgroundImage.width * currentBackgroundImage.scaleX);
                vm.canvas.setHeight(currentBackgroundImage.height * currentBackgroundImage.scaleY);
                vm.canvas.renderAll()
            },
            getUserTemplate: function () {
                let vm = this
                axios({
                    url: process.env.VUE_APP_API_BASE_URL + '/api/v1/user/me/template',
                    method: 'GET'
                }).then((response) => {
                    if (response.data.template) {
                        vm.canvas.loadFromJSON(response.data.template, vm.canvas.renderAll.bind(vm.canvas));
                    } else {

                        axios({
                            url: '/json/default_template_2.json',
                            method: 'GET'
                        }).then((response) => {
                            vm.canvas.loadFromJSON(response.data, vm.canvas.renderAll.bind(vm.canvas));
                        })

                    }

                })
            },
            setFontSize: function () {
                this.canvas.getActiveObject().set({fontSize: this.fontSize});
                this.canvas.renderAll()
            },
            setBackgroundColor: function () {
                this.canvas.getActiveObject().set({backgroundColor: this.backgroundColor});
                this.canvas.renderAll()
            },
            setTextColor: function () {
                this.canvas.getActiveObject().set({stroke: this.textColor});
                this.canvas.renderAll()
            },
            setFontFamily: function () {
                this.canvas.getActiveObject().set({fontFamily: this.fontFamily});
                this.canvas.renderAll()
            },
            addTextObject: function () {
                this.canvas.add(new fabric.IText('Lorem ipsum', {
                    left: 100, //Take the block's position
                    top: 100,
                    fill: 'black',
                    fontSize: 16
                }))

            },
            deleteFabricObject: function (obj = null) {
                console.log(obj)
                if (!obj) {
                    obj = this.canvas.getActiveObject()
                }
                this.canvas.remove(obj);
            },
            uploadImage: function () {
                var vm = this
                let data = this.$refs.cropper.getCroppedCanvas().toDataURL();

                var imgObject = document.createElement('img');
                imgObject.src = data;
                imgObject.style.display = "none";
                document.getElementById('app').appendChild(imgObject);

                imgObject.onload = function () {
                    let img = new fabric.Image(imgObject, {
                        left: 100,
                        top: 100
                    })
                    img.scaleToWidth(300);
                    vm.canvas.add(img);
                    vm.canvas.renderAll();
                };


            },
            save: function () {
                //get json from fabric js
                var json = JSON.stringify(this.canvas.toJSON());

                var vm = this
                axios({
                    url: process.env.VUE_APP_API_BASE_URL + '/api/v1/pdf/fabric',
                    method: 'POST',
                    data: {
                        json: JSON.parse(json),
                        paper_size: {
                            width: vm.pxToMm(vm.canvas.width),
                            height: vm.pxToMm(vm.canvas.height)
                        }
                    },
                    responseType: 'blob', // important
                }).then((response) => {
                    //Create a Blob from the PDF Stream
                    const file = new Blob(
                        [response.data],
                        {type: 'application/pdf'})//Build a URL from the file
                    const fileURL = URL.createObjectURL(file)//Open the URL on new Window

                    const content = response.headers['content-type'];
                    var today = new Date();
                    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
                    download(response.data, date + ' Pratica Cambiale .pdf', content)


                })


            },
            showFileChooser() {
                //document.getElementById("croppedImg").src = ''
                this.$refs.input.click();
            },
            deleteBackground: function () {
                var vm = this
                var currentBackgroundImage = this.canvas.getObjects().filter(function (o) {
                    return o.get('id') === 'background';
                });
                currentBackgroundImage.forEach(function (obj) {
                    vm.deleteFabricObject(obj)
                })
            },
            setBackground: function () {
                var vm = this
                if (typeof this.canvas.getActiveObject() !== 'undefined' && this.canvas.getActiveObject()) {
                    let objectType = this.canvas.getActiveObject().get('type')
                    if (objectType === "image") {

                        vm.deleteBackground()

                        let activeObject = this.canvas.getActiveObject()
                        this.canvas.sendToBack(activeObject)

                        activeObject.set('left', 0)
                        activeObject.set('top', 0)
                        activeObject.set('id', 'background')
                        //activeObject.set('selectable', false)
                        activeObject.scaleToWidth(fabric.util.parseUnit('297mm'));
                        this.canvas.renderAll();
                        this.canvas.discardActiveObject();
                        this.canvas.renderAll();
                    }
                }
            },
            setBackgroundC: function () {
                var vm = this
                if (typeof this.canvas.getActiveObject() !== 'undefined' && this.canvas.getActiveObject()) {
                    let objectType = this.canvas.getActiveObject().get('type')
                    if (objectType === "image") {

                        vm.deleteBackground()

                        let activeObject = this.canvas.getActiveObject()
                        this.canvas.sendToBack(activeObject)

                        activeObject.set('left', 0)
                        activeObject.set('top', 0)
                        activeObject.set('id', 'background')
                        //activeObject.set('selectable', false)
                        activeObject.scaleToWidth(fabric.util.parseUnit('221mm'));
                        this.canvas.renderAll();
                        this.canvas.discardActiveObject();
                        this.canvas.renderAll();
                    }
                }
            },
            setImage: function (e) {
                const file = e.target.files[0];
                if (file.type.indexOf('image/') === -1) {
                    alert('Please select an image file');
                    return;
                }
                if (typeof FileReader === 'function') {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        this.imgSrc = event.target.result;
                        // rebuild cropperjs with the updated source
                        this.$refs.cropper.replace(event.target.result);
                    };
                    reader.readAsDataURL(file);
                } else {
                    alert('Sorry, FileReader API not supported');
                }
            },
            pxToMm: function (px) {
                return Math.floor(px * 0.264583); //JQuery returns sizes in PX
            }
        }
    }
</script>